var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c69b7b59fa5b1104d5593dafc37cfc38d8491247"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["marketplace@fieldfolio"]={id:"c69b7b59fa5b1104d5593dafc37cfc38d8491247"};
      